<template>
  <div class="results">
    <Header />
    <div class="results__menu">
      <div class="container">
        <div class="container__content">
          <span class="container__title">wyniki wyszukiwania dla</span>

          <div class="results__width">
              <span class="results__query">{{this.query}}</span>
          <span
            class="results__item"
            v-for="(result, index) in resultsArray"
            v-bind:key="index"
            @click="goTo(result.name, result.id, result.number)"
          >{{result.name}}</span>

          <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
          </infinite-loading>
        </div>
        </div>
      </div>
    </div>
    <Rodo/>
  </div>
</template>

<script>
import Header from "@/components/Header/Mobile/Header.vue";
import InfiniteLoading from "vue-infinite-loading";
import Rodo from '@/components/Rodo/Mobile/Rodo.vue';
import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {
    Header,

    InfiniteLoading,
    Rodo
  },

  mounted() {}
};
</script>

<style scoped lang="scss">

.results {
  &__menu {
    margin-top: -17rem;
  }
  &__query {
      font-size: 1.5rem;
      font-family: 'Poppins', sans-serif;
      background-color: #d0d0e1;
      padding: 1rem 3rem;
      display: block;
      width: fit-content;
      margin: 1rem;



  }
  &__item {
  height: 3rem;
  width: 100%;
  border-top: 1px solid #d0d0e1;
      font-family: 'Poppins', sans-serif;
    font-weight: 700;
    display: flex;
    align-items: center;
        padding-left: 0.3rem;
    cursor: pointer;
    &:hover {
      font-size: 1.1rem;
      background-color: #d0d0e1;
    }
}
&__width {
    width: 94%;
    margin: auto;
}
  .container {
    width: 100%;
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex: 1;
    margin-top: 1.25rem;

    &__content {
      width: 94%;
      height: 100%;
      background-color: #fefefe;
      border-radius: 5px;

      min-height: 50rem;
      margin: auto;
    }

    &__title {
      font-size: 1.3rem;
      font-family: "Poppins", sans-serif;
      text-transform: uppercase;
      font-weight: 700;
      position: relative;
      margin-top: 4rem;
      display: inline-block;
      margin-left: 3rem;
      &:after {
        content: "";
        position: absolute;
        width: 1.1rem;
        height: 1.1rem;
        background-color: #df2860;
        left: -1.5rem;
        top: 0%;
      }
    }
  }
}
</style>
